module.exports = __webpack_public_path__ + "05a08df3b0560715f5c192d76541c76f.png";